/*
 * @Date: 2024-01-11 09:45:33
 * @Author: jm
 * @LastEditTime: 2024-01-11 14:43:10
 * @LastEditors: jm
 * @FilePath: \map\src\services\api.js
 * @Description: 
 */
import axiosInstance from "@/utils/request";

export const getgame = (params) => {
  return axiosInstance.post("games", { ...(params || {}) });
};
export const getgamemore = (params) => {
  return axiosInstance.post("gamesmore", { ...(params || {}) });
};
export const getgamesort = (params) => {
  return axiosInstance.post("gamesort", { ...(params || {}) });
};
export const getfind = (params) => {
  return axiosInstance.post("find", { ...(params || {}) });
};
